import { defaultIconProps, IconProps } from './IconProps';

type Props = IconProps & {
  firstPathColor?: string;
  secondPathColor?: string;
  thirdPathColor?: string;
  fourthPathColor?: string;
};

export const IconClarifaiSubscription: import('react').FC<Props> = ({
  size,
  firstPathColor = '#D0D5DD',
  secondPathColor = '#D0D5DD',
  thirdPathColor = '#D0D5DD',
  fourthPathColor = '#D0D5DD',
  ...rest
}) => {
  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path
        d="M28.2462 28.5284C31.0137 25.7609 29.529 24.115 31.3561 22.2879C32.713 20.9311 34.9271 20.9687 36.3001 22.3418C37.6731 23.7148 37.7108 25.9289 36.3539 27.2857C34.7015 28.9382 32.9079 27.6013 30.1135 30.3957C27.346 33.1632 28.8306 34.8091 27.0035 36.6362C25.6601 37.9796 23.4326 37.9554 22.0595 36.5823C20.6865 35.2093 20.6488 32.9952 22.0057 31.6384C23.6582 29.9859 25.4518 31.3228 28.2462 28.5284Z"
        fill={firstPathColor}
      />
      <path
        d="M12.0277 33.2409C13.4144 34.6277 15.6419 34.6519 16.9988 33.295C18.3557 31.9381 18.2909 29.7238 16.9178 28.3507C15.5448 26.9777 13.3173 26.9535 11.9739 28.2969C10.6304 29.6404 10.6409 31.8542 12.0277 33.2409Z"
        fill={secondPathColor}
      />
      <path
        d="M14.8726 15.128C17.6401 12.3605 16.1554 10.7146 17.9691 8.90099C19.326 7.5441 21.5535 7.56835 22.9265 8.94138C24.2995 10.3144 24.3372 12.5285 22.9803 13.8854C21.3279 15.5378 19.5343 14.2009 16.7399 16.9953C13.9724 19.7628 15.457 21.4087 13.6299 23.2358C12.2865 24.5792 10.059 24.555 8.68595 23.1819C7.31292 21.8089 7.27524 19.5948 8.63212 18.238C10.2846 16.5855 12.0782 17.9224 14.8726 15.128Z"
        fill={thirdPathColor}
      />
      <path
        d="M25.8603 17.7057C28.1711 15.395 26.4563 13.8145 28.2968 11.974C29.694 10.5768 31.9498 10.71 33.2408 12.0278C34.5451 13.3322 34.6918 15.5746 33.4155 16.8509C31.36 18.9064 29.6993 17.2994 27.5632 19.4354C25.2524 21.7462 26.9673 23.3266 25.1267 25.1672C23.743 26.5509 21.4871 26.4177 20.1827 25.1133C18.8784 23.809 18.7317 21.5665 20.008 20.2903C22.0635 18.2348 23.7242 19.8418 25.8603 17.7057Z"
        fill={fourthPathColor}
      />
    </svg>
  );
};

IconClarifaiSubscription.defaultProps = defaultIconProps;
